import React,{useEffect} from 'react';
import CommonIn from '../utils/CommonIn';

const Solutions = () => {
  useEffect(() => {
    // Code to execute after the component is mounted
    CommonIn();
  }, []); // Empty dependency array ensures this runs only once after initial render

  return (
    <>
     
      <main className="submain" id="submain">
        <div className="sub_header">
          <div className="container sub_header_inner">
            <h1>솔루션</h1>
          </div>
        </div>
        <div className="submenu">
          <div className="container">
            <div className="submenu_inner">
              <ul>
                <li><a href="#sol_access">출입 통제</a></li>
                <li><a href="#sol_adult">성인인증</a></li>
                <li><a href="#sol_kiosk">스마트 키오스크</a></li>
              </ul>
            </div>
          </div>
        </div>
        <section className="visual_sec solution_vs">
          <div className="container visual_inner">
            <div className="visual_text">
              <h2>"정확하고 안전한 출입, 얼굴로 인증하세요."</h2>
              <p>생체인식 기반으로 빠르고 확실한 출입통제를 실현합니다.</p>
            </div>
          </div>
        </section>
        <section className="sol_wrap snlink" id="sol_access">
          <div className="container">
            <div className="sol_tit_box">
              <p className="sol_tit">정밀한 출입통제,<br />조직 보안의 첫 걸음입니다.</p>
              <p>얼굴인식과 인증 데이터 기반의 출입 관리로 <br />복잡한 권한 설정부터 이력 추적까지,<br />정확하고 신뢰할 수 있는 보안 환경을 제공합니다.</p>
            </div>
            <div className="row">
              <div className="col">
                <div className="icon"><img src="../assets/images/sol01_icon01.png" alt="출입인증 장치 아이콘" /></div>
                <h3>정확한 얼굴인식 기반<br />출입인증 장치</h3>
                <p>RGB/IR 카메라 기반 얼굴 인식<br />99.9% 얼굴 인식<br />부정 매체 인증 시도 원천 차단</p>
              </div>
              <div className="col">
                <div className="icon"><img src="../assets/images/sol01_icon02.png" alt="바코드 및 RF 카드 연계 아이콘" /></div>
                <h3>다양한 기존 사원증<br />바코드/RF 카드 연계</h3>
                <p>도입기관 신분증 식별정보 연계 구축<br />다양한 인증 매체 지원</p>
              </div>
              <div className="col">
                <div className="icon"><img src="../assets/images/sol01_icon03.png" alt="출입 정책 아이콘" /></div>
                <h3>안전한 출입 정책<br />수립 및 관리</h3>
                <p>출입 구역별 출입자 설정<br />날짜 시간별 출입정책 상세 지원</p>
              </div>
              <div className="col">
                <div className="icon"><img src="../assets/images/sol01_icon04.png" alt="출입자 사후 검증 아이콘" /></div>
                <h3>직관적인 출입자<br />사후 검증</h3>
                <p>출입자 출입 사진 기반 사후 검증 지원</p>
              </div>
            </div>
          </div>
        </section>
        {/* <!--성인인증--> */}
        <section className="sol_wrap snlink" id="sol_adult">
          <div className="container">
            <div className="sol_tit_box">
              <p className="sol_tit">AI 기반 성인인증,<br/>신뢰할 수 있는 접근 제어</p>
              <p>생체정보와 신분 검증을 결합한 고정밀 인증 시스템으로
                <br/>연령 제한 콘텐츠 및 서비스 이용 시, 법적 요건을 완벽히
                <br/>충족하는 인증 환경을 제공합니다.</p>
            </div>
            <div>
              <div className="row">
                <div className="col">
                  <div className="icon"><img src="../assets/images/sol02_icon01.png" alt="정확한 신분증 OCR 아이콘"/></div>
                  <h3>정확한 신분증 OCR</h3>
                  <p>국내 신분증/운전면허증 등 OCR 인식</p>
                </div>
                <div className="col">
                  <div className="icon"><img src="../assets/images/sol02_icon02.png" alt="신분증 식별 아이콘"/></div>
                  <h3>안전한 부정 신분증 식별</h3>
                  <p>신분증 사본 및 합성 감지</p>
                </div>
                <div className="col">
                  <div className="icon"><img src="../assets/images/sol02_icon03.png" alt="신분증 실물 확인 아이콘"/></div>
                  <h3>신분증 실물 확인</h3>
                  <p>원본 여부 검증 지원</p>
                </div>
              </div>
            </div>
          </div>  
        </section>
        {/* <!--//성인인증-->
        <!--스마트 키오스크--> */}
        <section className="sol_wrap snlink" id="sol_kiosk">
          <div className="container">
            <div className="sol_tit_box">
              <p className="sol_tit">스마트 키오스크,<br/>비대면 업무의 새로운 표준</p>
              <p>AI 인증 기술과 직관적인 UI를 기반으로
                <br/>무인 접수·출입·확인을 자동화하여 현장 운영 효율성과
                <br/>사용자 만족도를 동시에 높입니다.</p>
            </div>
            <div>
              <div className="row">
                <div className="col">
                  <div className="icon"><img src="../assets/images/sol03_icon01.png" alt="얼굴인식 아이콘"/></div>
                  <h3>AI 카메라 기반<br/>얼굴인식 SDK</h3>
                  <p>국내 신분증/여권 OCR과 연동</p>
                </div>
                <div className="col">
                  <div className="icon"><img src="../assets/images/sol03_icon02.png" alt="동기화 서버 아이콘"/></div>
                  <h3>멀티 카메라 등록 인원<br/>동기화 서버 구축</h3>
                  <p>신분증 사진 교체 감지
                    신분증 촬영본 탐지</p>
                </div>
                <div className="col">
                  <div className="icon"><img src="../assets/images/sol03_icon03.png" alt="키오스크 아이콘"/></div>
                  <h3>윈도우 기반<br/>키오스크/PC 지원</h3>
                  <p>행안부/경찰청</p>
                </div>
              </div>
            </div>
          </div>  
        </section>
  {/* <!--//스마트 키오스크--> */}
      </main>
     
    </>
  );
};

export default Solutions;